module.exports = __webpack_public_path__ + "static/nnu-7e907f7fb6bbd25373b9d8e185bbbe13.png";